 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		4: 0
 	};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		4: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"styles","1":"commons","2":"dbb05038a9957299b881736faaf694e13721a54c","3":"f149ad46232e1b415bfb5304fa987bc56d49933b","6":"component---src-pages-404-tsx","7":"component---src-pages-index-tsx","8":"component---src-pages-members-alumni-tsx","9":"component---src-pages-members-present-tsx","10":"component---src-pages-projects-ongoing-projects-2020-hku-covid-19-mdx","11":"component---src-pages-projects-ongoing-projects-2020-hku-me-mdx","12":"component---src-pages-projects-ongoing-projects-2020-hku-seedfund-mdx","13":"component---src-pages-projects-ongoing-projects-2020-rgc-ecs-mdx","14":"component---src-pages-projects-ongoing-projects-2021-rgc-grf-mdx","15":"component---src-pages-projects-ongoing-projects-2023-nsfc-eysf-mdx","16":"component---src-pages-projects-ongoing-projects-2024-hubei-mdx","17":"component---src-pages-projects-ongoing-projects-2024-nsfc-ysf-mdx","18":"component---src-pages-projects-ongoing-projects-index-tsx","19":"component---src-pages-projects-past-projects-index-tsx","20":"component---src-pages-projects-past-projects-lohcool-mdx","21":"component---src-pages-projects-past-projects-magic-mdx","22":"component---src-pages-projects-past-projects-urban-warming-of-phoenix-usa-mdx","23":"component---src-pages-research-themes-building-energy-efficiency-mdx","24":"component---src-pages-research-themes-urban-biometeorology-mdx","25":"component---src-pages-research-themes-urban-blue-infrastructure-mdx","26":"component---src-pages-research-themes-urban-fluid-mechanics-mdx","27":"component---src-pages-research-themes-urban-green-infrastructure-mdx","28":"component---src-pages-research-themes-urban-hydro-climate-mdx","29":"component---src-pages-research-themes-urban-land-atmosphere-interaction-mdx","30":"component---src-pages-team-activities-conferences-and-meetings-tsx","31":"component---src-pages-team-activities-fun-mdx"}[chunkId]||chunkId) + "-" + {"0":"407fe62976dc5310c43e","1":"386f1603f935af691315","2":"d61e48047245944a21e5","3":"e3d801a3045260b3bac5","6":"03515f20a3e70f779ccf","7":"d157af073e7298a66489","8":"0009356a4c1229d8fd52","9":"b6de6f6472ac09415ad7","10":"f90c566340a30033d563","11":"acc2d8fcfbfd09cf2eb8","12":"f230e0bcca08571759a5","13":"ebbb65000aa733331d9b","14":"acb1c5d04375da44ccf6","15":"322ab02de2b31aa64d6e","16":"d872e2078177dfb198dd","17":"9d590833ed275e3b75c5","18":"7a7efe93a2b7787411d4","19":"c44e17e788a634135736","20":"e3435518a33a78f4b48d","21":"3cdcaee028296b07b802","22":"ce71337e4238eb745071","23":"e5db7d51509a3f767eec","24":"43d71e312ee43265eaac","25":"c05ec234547f2a5634c4","26":"6bf39bf4d40e274181b5","27":"c1dd4c54249da33739a7","28":"3dc7f1953d8f41d454fc","29":"c80372aa6e79ccb10586","30":"5aed54fb7932ae092a1c","31":"8e6ec5a7a026d1a63180"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"0":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"0":"styles","1":"commons","2":"dbb05038a9957299b881736faaf694e13721a54c","3":"f149ad46232e1b415bfb5304fa987bc56d49933b","6":"component---src-pages-404-tsx","7":"component---src-pages-index-tsx","8":"component---src-pages-members-alumni-tsx","9":"component---src-pages-members-present-tsx","10":"component---src-pages-projects-ongoing-projects-2020-hku-covid-19-mdx","11":"component---src-pages-projects-ongoing-projects-2020-hku-me-mdx","12":"component---src-pages-projects-ongoing-projects-2020-hku-seedfund-mdx","13":"component---src-pages-projects-ongoing-projects-2020-rgc-ecs-mdx","14":"component---src-pages-projects-ongoing-projects-2021-rgc-grf-mdx","15":"component---src-pages-projects-ongoing-projects-2023-nsfc-eysf-mdx","16":"component---src-pages-projects-ongoing-projects-2024-hubei-mdx","17":"component---src-pages-projects-ongoing-projects-2024-nsfc-ysf-mdx","18":"component---src-pages-projects-ongoing-projects-index-tsx","19":"component---src-pages-projects-past-projects-index-tsx","20":"component---src-pages-projects-past-projects-lohcool-mdx","21":"component---src-pages-projects-past-projects-magic-mdx","22":"component---src-pages-projects-past-projects-urban-warming-of-phoenix-usa-mdx","23":"component---src-pages-research-themes-building-energy-efficiency-mdx","24":"component---src-pages-research-themes-urban-biometeorology-mdx","25":"component---src-pages-research-themes-urban-blue-infrastructure-mdx","26":"component---src-pages-research-themes-urban-fluid-mechanics-mdx","27":"component---src-pages-research-themes-urban-green-infrastructure-mdx","28":"component---src-pages-research-themes-urban-hydro-climate-mdx","29":"component---src-pages-research-themes-urban-land-atmosphere-interaction-mdx","30":"component---src-pages-team-activities-conferences-and-meetings-tsx","31":"component---src-pages-team-activities-fun-mdx"}[chunkId]||chunkId) + "." + {"0":"e4d197430c6aeaaf0025","1":"31d6cfe0d16ae931b73c","2":"31d6cfe0d16ae931b73c","3":"31d6cfe0d16ae931b73c","6":"31d6cfe0d16ae931b73c","7":"31d6cfe0d16ae931b73c","8":"31d6cfe0d16ae931b73c","9":"31d6cfe0d16ae931b73c","10":"31d6cfe0d16ae931b73c","11":"31d6cfe0d16ae931b73c","12":"31d6cfe0d16ae931b73c","13":"31d6cfe0d16ae931b73c","14":"31d6cfe0d16ae931b73c","15":"31d6cfe0d16ae931b73c","16":"31d6cfe0d16ae931b73c","17":"31d6cfe0d16ae931b73c","18":"31d6cfe0d16ae931b73c","19":"31d6cfe0d16ae931b73c","20":"31d6cfe0d16ae931b73c","21":"31d6cfe0d16ae931b73c","22":"31d6cfe0d16ae931b73c","23":"31d6cfe0d16ae931b73c","24":"31d6cfe0d16ae931b73c","25":"31d6cfe0d16ae931b73c","26":"31d6cfe0d16ae931b73c","27":"31d6cfe0d16ae931b73c","28":"31d6cfe0d16ae931b73c","29":"31d6cfe0d16ae931b73c","30":"31d6cfe0d16ae931b73c","31":"31d6cfe0d16ae931b73c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
